import { contextStore } from "./context-store.js";

/**
 * O contexto de uma chamada de serviço a partir da SESSÃO: Cliente ativo,
 * permissões, usuário e Professional.
 *
 * Várias telas montavam `{ activeClientId } as any` — sem permissões. No
 * teste local os serviços negavam tudo (o Administrador recebia "você não
 * possui a permissão equipment.read"); no servidor o /api/rpc remonta o
 * contexto pela sessão, e por isso o defeito só aparecia num dos modos.
 */
export function sessionRequestContext(): any {
  const c = contextStore.get();
  return {
    activeClientId: c.activeClientId || undefined,
    permissions: c.permissions,
    correlationId: "",
    userId: c.userId,
    professionalId: c.professionalId || null
  };
}
